import React, { useState, useEffect, useRef } from 'react'
import { graphql, Link } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Fade from 'react-reveal/Fade'

import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import Layout from 'components/Layout'

const Article = ({ data }) => {

  const FeaturedImage = () => {
    if ( data.strapiArticles.featuredImage !== null ) {
      const image = getImage(data.strapiArticles.featuredImage.localFile)
      return <GatsbyImage image={image} alt="" className="mb-8" />
    }
    return null
  }
    const articleDate = new Date(data.strapiArticles.created_at)

    return (
        <Layout pageTitle={ data.strapiArticles.title } pageGroup="update" floatingHeader={ false }>
            <section className="single-article">
                <ResponsiveContainer className="pt-12 pb-24">
                    <div className="lg:w-9/12 lg:mx-auto">
                        <Fade>
                            <FeaturedImage />
                            <div className="text-sm mb-8">{ articleDate.getDate()} { articleDate.toLocaleString('en-en', { month: 'long' }) } { articleDate.getFullYear() }&emsp;<span className="text-primary font-bold">{ data.strapiArticles.article_category.name }</span></div>
                            <h1 className="h1">{ data.strapiArticles.title }</h1>
                            <ReactMarkdown children={ data.strapiArticles.content } />
                        </Fade>
                    </div>
                </ResponsiveContainer>
            </section>
            
        </Layout>
    )
}

export const pageQuery = graphql`
  query ArticlePageQuery($id: String!) {
    strapiArticles(id: {eq: $id}) {
      article_category {
        name
        id
      }
      content
      created_at
      featuredImage {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 1000
              formats: WEBP
              backgroundColor: "#eaeaea"
              placeholder: NONE
            )
          }
        }
      }
      id
      title
    }
  }
`


export default Article
